var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestLabSecondary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(20 11.5 11.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.665 6.32738C15.8068 6.08183 15.7227 5.76783 15.4772 5.62606C15.2316 5.48429 14.9176 5.56839 14.7758 5.81394L10.7912 12.7155C10.6495 12.9611 10.7336 13.275 10.9792 13.4168C11.2247 13.5586 11.5387 13.4744 11.6805 13.2289L15.665 6.32738ZM5.8755 9.51979C5.73373 9.7654 5.81788 10.0794 6.06343 10.2212C6.30898 10.3629 6.62298 10.2788 6.76475 10.0332L10.5945 3.39988C10.7363 3.15433 10.6521 2.84033 10.4066 2.69856C10.161 2.55679 9.84702 2.64094 9.70525 2.88649L5.8755 9.51979Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0127 4.35416L10.2476 -0.140045C10.134 -0.20576 9.98872 -0.166988 9.923 -0.0534439L8.71196 2.03901C8.64624 2.15256 8.68502 2.29787 8.79856 2.36359L16.5637 6.8578C16.6772 6.92351 16.8226 6.88474 16.8883 6.7712L18.0993 4.67874C18.165 4.5652 18.1263 4.41988 18.0127 4.35416Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.21042 8.41479L8.87319 9.37476L8.46746 10.0807L6.80469 9.12072L7.21042 8.41479Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.0095 7.03491L9.05712 7.63977L8.64826 8.3457L7.60059 7.74084L8.0095 7.03491Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.80509 5.65405L10.4679 6.61402L10.0622 7.32001L8.39941 6.36004L8.80509 5.65405Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03141 21.282L11.6806 13.2294C11.0184 12.847 10.511 12.1965 9.84881 11.8142C9.18665 11.4319 8.36962 11.3177 7.70741 10.9354C7.0452 10.5531 6.53781 9.9026 5.87565 9.52026L1.07162 17.8411C0.125389 19.4801 0.692096 21.5951 2.3311 22.5414C3.97004 23.4877 6.08518 22.9209 7.03141 21.282Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5268 5.6297C19.3694 7.02235 18.8357 8.16479 18.7018 9.057C18.4585 10.6773 19.5334 11.4726 20.584 11.4427C21.5904 11.414 22.5746 10.628 22.3559 9.0847C22.2289 8.18845 21.6963 7.03678 20.5268 5.6297Z",
    fill: "#61A333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestLabSecondary);
export default __webpack_public_path__ + "static/media/Test-Lab-Secondary.bf5710d5ab3fe9037d5219ea2a47913d.svg";
export { ForwardRef as ReactComponent };